/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsFormsExcelResult } from '../classes/forms-excel/ds-forms-excel-result.class';
/** Interfaces */
import { DsFormsExcelResultInterface } from '../interfaces/forms-excel/ds-forms-excel-result.interface';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsFormExcelImportService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Upload excel file.
   *
   * @param file Excel file that follows the user guide
   * @returns Observable<DsFormsExcelResult>
   */
  public uploadExcel(file: File): Observable<DsFormsExcelResult> {
    this.path = `/v1/dsform/excelconvertion/sheets`;
    const body = new FormData();
    body.append('file', file);
    const headers = this.bydConfigService.headers.delete('Content-Type');
    return this.postModel<DsFormsExcelResult>({ body, headers });
  }

  /**
   * Create DsFormsExcelResult instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormsExcelResult` instance.
   */
  public createNewInstance(jsonObject: DsFormsExcelResultInterface): DsFormsExcelResult {
    return new DsFormsExcelResult(jsonObject);
  }
}
